import { useEffect } from 'react';

import { useLocation } from '@reach/router';
import { useEthers } from '@usedapp/core';

import { PROVIDER_OPTIONS } from '../context/constants';
import { useDispatch, useTrackedState } from '../context/store';
import { TExchangeProvider } from '../context/types';

import { redirect } from '../helpers/redirect';

// only runs when user clicks on the menu button.
const useRedirectOnPath = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { chainId } = useEthers();
  const { provider: exchangeProvider } = useTrackedState();

  useEffect(() => {
    const segments = location.pathname.split('/').filter(Boolean);
    const firstSegment = segments[0] ?? '';
    if (segments.length === 1) {
      redirect(chainId, firstSegment);
      const prov =
        PROVIDER_OPTIONS.filter(p => p.chain === chainId) ?? 'bitcoincom_eth';

      if (prov[0]?.provider !== exchangeProvider) {
        dispatch({
          type: 'SET_PROVIDER',
          payload: prov[0].provider as TExchangeProvider,
        });
      }
    }
  }, [
    location,
    chainId,
    exchangeProvider,
    PROVIDER_OPTIONS,
    redirect,
    dispatch,
  ]);
};

export default useRedirectOnPath;
